import Vue from "vue";

export const store = Vue.observable({
    authenticated: false,
    host: { email: "" },
    currentEstablishmentReference: "",
    currentEstablishmentProviderChannels: [],
    isNavOpen: false,
    title: "",
    forceScrollbars: false,
    hasIntegrations: false
});

export const mutations = {
    signIn(host) {
        store.authenticated = true;
        store.host = host;
    },
    signOut() {
        store.authenticated = false;
        store.authorisationToken = null;
        store.currentEstablishmentReference = "";
        store.currentEstablishmentProviderChannels = [];
        store.host = { email: "" };
    },
    setHost(host) {
        store.host = host;
    },
    addEstablishment(establishment) {
        store.host.establishments.push(establishment)
    },
    updateEstablishment(establishment) {
        for (let i = 0; i < store.host.establishments.length; i++) {
            let existing = store.host.establishments[i];
            if (establishment.reference === existing.reference) {
                store.host.establishments.splice(i, 1, establishment);
                return;
            }
        }
    },
    removeEstablishment(reference) {
        if (store.host.establishments.length > 0) {
            let filteredList = store.host.establishments.filter(function(establishment){
                return establishment.reference != reference;
            });

            if (store.currentEstablishmentReference === reference) {
                if (filteredList.length > 0) {
                    store.currentEstablishmentReference = filteredList[0].reference
                } else {
                    store.currentEstablishmentReference = null
                }
            }
            store.host.establishments = filteredList
        }
    },
    setCurrentEstablishmentReference(establishmentReference) {
        store.currentEstablishmentReference = establishmentReference
    },
    setCurrentEstablishmentProviderChannels(providerChannels) {
        store.currentEstablishmentProviderChannels = providerChannels;
    },
    toggleNav() {
        store.isNavOpen = !store.isNavOpen
    },
    hideNav() {
        store.isNavOpen = false
    },
    setTitle(title) {
        store.title = title
    },
    setForceScrollbars() {
        store.forceScrollbars = true;
    },
    setIntegrations(hasIntegrations) {
        store.hasIntegrations = hasIntegrations;
    }
};

export const getters = {
    isAuthenticated() {
        return store.authenticated
    },
    getUsersInitials() {
        if (store.host !== undefined && store.host.name !== undefined) {
            return store.host.name.match(/\b(\w)/g).join('')
        }
        return ""
    },
    isOnboardingComplete() {
        if (store.host !== undefined && store.host.state === "active") {
            return true;
        }
        return false;
    },
    canShowWhatsApp() {
        return true;
        // return store.host.email.startsWith("duncan") || 
        //        store.host.email.startsWith("test@betterguest") || 
        //        store.host.email.endsWith("nightsbridge.co.za") || 
        //        store.host.email.endsWith("nightsbridge.com");
    },
    hasMultipleEstablishments() {
        return store.host.establishments && store.host.establishments.length > 1;
    },
    getCurrentEstablishment() {
        return this.getEstablishmentByReference(store.currentEstablishmentReference)
    },
    getEstablishmentByReference(reference) {
        if (store.host.establishments) {
            let currentEstablishment = store.host.establishments.filter(establishment => establishment.reference === reference)
            if (currentEstablishment !== undefined && currentEstablishment.length > 0) {
                return currentEstablishment[0]
            }
        }

        return null
    },
    doesCurrentEstablishmentHaveHeaderImage() {
        if (this.getCurrentEstablishment().preferences.logo) {
            return true;
        }
        return false;
    },
    getCurrentEstablishmentHeaderImage() {
        if (this.doesCurrentEstablishmentHaveHeaderImage) {
            const currentEstablishment = this.getCurrentEstablishment();
            for (let image of currentEstablishment.preferences.images) {
                if (image.reference === currentEstablishment.preferences.logo) {
                    return image;
                }
            }
        }
        return "";
    },
    // getCurrentEstablishmentUnitTypeForDisplay() {
    //     return this.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
    // }
};